import React from 'react';
import Spinner from '../Spinner';

const Loading = () => <div><Spinner /></div>;

export default Loading;
